// userInfoSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { PROFILE_INFORMATION } from "../../data/EndorsementConstants";

// initial state for user info stepper
const initialState = {
    loading: false,
    currentStep: 1,
    complete: false,
    tableDetails: [],

    currentSelfCheckStep: 1,
    selfCheckComplete: false,
    selfCheckTableDetails: [],

    currentTSTCStep: 1,
    TSTCComplete: false,
    TSTCTableDetails: [],
    profileDetailsType: PROFILE_INFORMATION.BASIC_INFORMATION,
    notifyEndorsementStatus: null,
};

// Create the for user info stepper slice
const userInfoSlice = createSlice({
    name: "userInfoStepper",
    initialState,
    reducers: {
        handleLoading: (state, action) => {
            state.loading = action.payload;
        },
        handleCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        handleCompletedStep: (state, action) => {
            state.complete = action.payload;
        },
        handleTableDetails: (state, action) => {
            state.tableDetails = action.payload;
        },
        clearTableDetails: (state, action) => {
            state.tableDetails = [];
        },
        handleCurrentSelfCheckStep: (state, action) => {
            state.currentSelfCheckStep = action.payload;
        },
        handleSelfCheckCompletedStep: (state, action) => {
            state.selfCheckComplete = action.payload;
        },
        clearSelfTableDetails: (state, action) => {
            state.selfCheckTableDetails = [];
        },
        handleCurrentTSTCStep: (state, action) => {
            state.currentTSTCStep = action.payload;
        },
        handleTSTCCompleted: (state, action) => {
            state.TSTCComplete = action.payload;
        },
        handleProfileInformationType: (state, action) => {
            state.profileDetailsType = action.payload;
        },
        handleNotifyEndorsementStatus: (state, action) => {
            state.notifyEndorsementStatus = action.payload;
        },
    },
});

// Export the authentication actions and reducer
export const {
    handleLoading,
    handleCurrentStep,
    handleCompletedStep,
    handleTableDetails,
    clearTableDetails,
    handleCurrentSelfCheckStep,
    handleSelfCheckCompletedStep,
    handleCurrentTSTCStep,
    handleTSTCCompleted,
    handleProfileInformationType,
    handleNotifyEndorsementStatus,
} = userInfoSlice.actions;
export default userInfoSlice.reducer;
